<style type="text/css">
.blog_table_footer {
    display: flex;
    box-sizing: content-box;
    padding-top: 10px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    justify-content: space-between;
}
</style>
<template>
    <div>
        <div style="display: flex;justify-content: flex-start;margin-top:20px">
            <el-select v-model="selectBannerType" style="margin-left: 20px" @change="handleSelectChange" placeholder="通过类型搜索改分类下的banner...">
                <el-option v-for="item in BannerOptions" :key="item.id" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 20px" @click="addBanner">添加banner</el-button>
        </div>
        <el-table ref="multipleTable" :data="bannerLists" tooltip-effect="dark" style="width: 100%;overflow-x: hidden; overflow-y: hidden;" max-height="600" v-loading="loading">
            <el-table-column label="标题" width="140" align="left">
                <template slot-scope="scope">
                    <span style="color: #409eff;cursor: pointer" @click="itemClick(scope.row)">{{ scope.row.bannerTitle }}</span>
                </template>
            </el-table-column>
            <el-table-column label="最近编辑时间" width="140" align="left">
                <template slot-scope="scope">{{ scope.row.updateTime | formatDateTime }}</template>
            </el-table-column>
            <el-table-column label="pc-banner图片" width="200" align="left">
                <template slot-scope="scope">
                    <el-popover placement="top" width="200" trigger="hover">
                        <img slot="reference" :src="scope.row.bannerPc" style="width: 140px; height: 60px" />
                        <img style="max-width: 200px" :src="scope.row.bannerPc" />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="iphone-banner图片" width="200" align="left">
                <template slot-scope="scope">
                    <el-popover placement="top" width="200" trigger="hover">
                        <img slot="reference" :src="scope.row.bannerIphone" style="width: 140px; height: 60px" />
                        <img style="max-width: 200px" :src="scope.row.bannerIphone" />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="所属分类" width="120" align="left">
                <template slot-scope="scope">{{ scope.row.index }}</template>
            </el-table-column>
            <el-table-column label="操作" align="left">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="blog_table_footer">
            <span></span>
            <!-- <el-pagination
                background
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="totalCount"
                @current-change="currentChange"
                v-show="this.productLists.length > 0"
            ></el-pagination> -->
        </div>
    </div>
</template>

<script>
import { putRequest, getRequest, postRequest, uploadFileRequest } from '@/utils/api';
export default {
    data() {
        return {
            bannerLists: [],
            loading: false,
            selectBannerType: '',
            BannerOptions: [
                { id: 1, label: '首页', value: 'index' },
                { id: 2, label: '产品', value: 'product' },
                { id: 3, label: '资讯', value: 'news' },
            ],
        };
    },
    mounted: function() {
        this.loading = false;
    },
    methods: {
        handleSelectChange() {
            console.log(this.selectBannerType);
        },
        addBanner() {
            this.$router.replace({ path: '/addBanner' });
        },
        itemClick(row) {
            console.log(row);
        },
        handleEdit(row) {
            console.log(row);
        },
        handleDelete(row) {
            console.log(row);
        },
        errorInfo(info) {
            this.$message({ type: 'info', message: info });
        },
        successInfo(info) {
            this.$message({ type: 'success', message: info });
        },
        failedInfo(info) {
            this.$message({ type: 'error', message: info });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/banner/bannerList.vue